// API Reference: https://www.wix.com/velo/reference/api-overview/introduction
// “Hello, World!” Example: https://learn-code.wix.com/en/article/1-hello-world
import wixUsers from "wix-users"
import wixLocation from 'wix-location';

$w.onReady(function () {
});


export function icare_click(event) {
	console.log("button click")
	console.log("User logged in? - " + wixUsers.currentUser.loggedIn)
	if (wixUsers.currentUser.loggedIn) {
		wixLocation.to("/icare-members")
	}
	else {
		wixLocation.to("/private-icare")
	}
}